(function () {
  'use strict';

  function getContext() {
    var context = window.__FY_ANALYTICS_CONTEXT__;
    return context && typeof context === 'object' ? context : null;
  }

  function hasOptedOut(posthogInstance) {
    if (!posthogInstance || typeof posthogInstance.has_opted_out_capturing !== 'function') {
      return false;
    }

    try {
      return posthogInstance.has_opted_out_capturing() === true;
    } catch (error) {
      return false;
    }
  }

  function waitForPostHogReady(options) {
    var settings = options || {};
    var intervalMs = typeof settings.intervalMs === 'number' ? settings.intervalMs : 100;
    var timeoutMs = typeof settings.timeoutMs === 'number' ? settings.timeoutMs : 8000;

    return new Promise(function (resolve) {
      var start = Date.now();
      var settled = false;

      function finish(posthogInstance) {
        if (settled) {
          return;
        }

        settled = true;
        resolve(posthogInstance || null);
      }

      function getReadyPosthog() {
        var posthogInstance = window.posthog;
        if (posthogInstance && typeof posthogInstance.capture === 'function') {
          return posthogInstance;
        }

        return null;
      }

      var readyNow = getReadyPosthog();
      if (readyNow) {
        finish(readyNow);
        return;
      }

      var timer = setInterval(function () {
        var posthogInstance = getReadyPosthog();
        if (posthogInstance) {
          clearInterval(timer);
          finish(posthogInstance);
          return;
        }

        if (Date.now() - start >= timeoutMs) {
          clearInterval(timer);
          finish(null);
        }
      }, intervalMs);
    });
  }

  window.__JH_POSTHOG_UTILS__ = {
    waitForPostHogReady: waitForPostHogReady,
    hasOptedOut: hasOptedOut,
    getContext: getContext
  };
})();
